import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseIndexPageComponent } from '../../../components/pages/base-index-page/base-index-page.component';
import BaseIndexPageConfig from '../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../services/api/api-options.config';
import { RouteService } from '../../../services/route.service';
import { CustomerService } from '../../../services/api/customer.service';
import { MainLayoutService } from '../../../services/main-layout.service';
import { AccessControlService } from '../../../services/access-control.service';

@Component({
  selector: 'app-customers-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './customers-index-page.component.html',
  styleUrl: './customers-index-page.component.scss'
})
export class CustomersIndexPageComponent implements OnInit, OnDestroy {
  baseIndexPageConfig: BaseIndexPageConfig;
  CustomersService: any;
  private subscriptions = new Subscription();

  constructor(
    protected customerService: CustomerService,
    private routeService: RouteService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Client List',
      cardTitle: 'CLIENTS',
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'code',
            header: 'Code',
            width: '70px',
            filter: 'text',
            value: (item: any) => {
              return item.code;
            }
          }),
          new DataTableColumnText({
            attribute: 'ranking',
            header: 'Rnk',
            filter: 'select',
            filterOptionsSource:'ranking',
            value: (item: any) => {
              return item.ranking;
            }
          }),
          new DataTableColumnText({
            attribute: 'isClient',
            header: 'Is Client',
            filter: 'select',
            filterOptionsSource: 'isClient',
            value: (item: any) => {
              return item.isClient === true ? 'Yes' : 'No';
            }
          }),new DataTableColumnText({
            attribute: 'brand',
            header: 'Brand',
            filter: 'text',
            value: (item: any) => {
              return item.brand;
            }
          }),
          new DataTableColumnText({
            attribute: 'companyName',
            header: 'Company Name',
            filter: 'text',
            value: (item: any) => {
              return item.companyName;
            }
          }),          
          new DataTableColumnText({
            attribute: 'city',
            header: 'City',
            filter: 'text',
            value: (item: any) => {
              return item.city;
            }
          }),
          new DataTableColumnText({
            attribute: 'country',
            header: 'Country',
            filter: 'text',
            value: (item: any) => {
              return item.country.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'surname',
            header: 'Surname',
            filter: 'text',
            value: (item: any) => {
              return item.decisionMaker?.lastName;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            width: '50px',
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View client details',
                onClick: (item: any) => {
                  this.routeService.customerDetail(item.customerId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit client',
                onClick: (item: any) => {
                  this.routeService.customerUpdate(item.customerId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete client',
                onClick: (item: any) => {
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.customerService.list(options),
      responseListModelName: 'customers',
    }
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.mainLayoutService.activeProfile$.subscribe(profileCode => {
        const canCreate = this.accessControlService.hasFeatureActionAccess(profileCode, 'CLIENTS_LIST', 'modify');
        this.baseIndexPageConfig.addNewItemButton = canCreate
          ? {
              type: 'success',
              title: 'New Client',
              onClick: () => this.routeService.customerCreate()
            }
          : undefined;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
